import { api } from "./api";

import type {
  PaymentRequestLinks,
  PaymentRequestPriceData,
  UpdatePaymentRequestLinksPayload,
} from "../../types/PaymentRequestLinkTypes";
import { PaginatedResponse } from "../../types/GlobalTypes";
import { transformObjectFields } from "../../utils/objects";

const transformResponsePaymentRequestLink = (response: PaymentRequestLinks) =>
  transformObjectFields<PaymentRequestLinks>(response, {
    month_eur_total: Number,
    eur_monthly_limit: Number,
    eur_price: Number,
    gbp_price: Number,
    forex_eur_price: Number,
    forex_gbp_price: Number,
    commission: Number,
    tds: Number,
    max_gbp_amount_threshold: Number,
    max_eur_amount_threshold: Number,
    min_amount_threshold: Number,
  });

const transformPaymentRequestPriceData = (response: PaymentRequestPriceData) =>
  transformObjectFields<PaymentRequestPriceData>(response, {
    eur_price: Number,
    gbp_price: Number,
    forex_eur_price: Number,
    forex_gbp_price: Number,
    commission: Number,
    tds: Number,
    max_gbp_amount_threshold: Number,
    max_eur_amount_threshold: Number,
    min_amount_threshold: Number,
  });

export interface PaymentRequestResponse
  extends PaginatedResponse<PaymentRequest> {}

export const paymentRequestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentRequestLink: builder.query<PaymentRequestLinks, void>({
      query: () => ({
        url: `/payment_request_links/`,
      }),
      providesTags: ["PaymentRequestLinks"],
      transformResponse: transformResponsePaymentRequestLink,
    }),
    getPaymentRequestLinkPublic: builder.query<PaymentRequestLinks, string>({
      query: (id) => ({
        url: `public/payment_request_links/${id}/`,
      }),
      transformResponse: transformResponsePaymentRequestLink,
    }),
    updatePaymentRequestLink: builder.mutation<
      PaymentRequestLinks,
      UpdatePaymentRequestLinksPayload
    >({
      query: (payload) => ({
        url: "/payment_request_links/",
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["PaymentRequestLinks"],
    }),
    getPublicPaymentRequestPriceData: builder.query<
      PaymentRequestPriceData,
      void
    >({
      query: () => ({
        url: "/public/payment_request_price_data/",
      }),
      providesTags: ["PaymentRequests"],
      transformResponse: transformPaymentRequestPriceData,
    }),
  }),
});

export const {
  useGetPaymentRequestLinkQuery,
  useGetPaymentRequestLinkPublicQuery,
  useUpdatePaymentRequestLinkMutation,
  useGetPublicPaymentRequestPriceDataQuery,
} = paymentRequestApi;
